import React from "react";
import "./HowJibuBotWorks.css";
import { FaPlug, FaCogs, FaRobot, FaChartLine } from "react-icons/fa";

const steps = [
  {
    icon: <FaPlug />,
    title: "Connect",
    description: "Integrate JibuBot with your website, app, or CRM using easy-to-follow steps.",
  },
  {
    icon: <FaCogs />,
    title: "Customize",
    description: "Define how JibuBot behaves, from FAQs to flows, using simple configuration tools.",
  },
  {
    icon: <FaRobot />,
    title: "Automate",
    description: "Let JibuBot handle conversations, resolve issues, and guide users 24/7.",
  },
  {
    icon: <FaChartLine />,
    title: "Monitor & Improve",
    description: "Access analytics and continuously improve performance with real-time feedback.",
  },
];

const HowJibuBotWorks = ({ isDarkMode }) => {
  return (
    <section className={`how-jibubot-works ${isDarkMode ? "dark-mode" : "light-mode"}`}>
      <h2>How JibuBot Works</h2>
      <p className="subtext">Launch your smart chatbot in just a few simple steps.</p>

      <div className="step-list">
        {steps.map((step, index) => (
          <div className="step-block" key={index}>
            <div className="icon">{step.icon}</div>
            <h3>
              <span className="step-number">Step {index + 1}:</span> {step.title}
            </h3>
            <p>{step.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default HowJibuBotWorks;
